import React from 'react';

import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { WorkingHours } from 'src/features/workingHours/utils/types';
import { useCreateWorkingHoursException } from 'src/features/workingHoursExceptions/api/useCreateWorkingHours';
import { LIST_WORKING_HOURS_EXCEPTIONS_RESOURCE } from 'src/features/workingHoursExceptions/api/useListWorkingHoursExceptions';
import WorkingHoursExceptionsFormModal from 'src/features/workingHoursExceptions/components/form/WorkingHoursExceptionsFormModal';
import { workingHoursMessages } from 'src/features/workingHoursExceptions/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { useParking } from 'src/providers/ParkingProvider';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface WorkingHoursFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedWorkingHours?: WorkingHours;
    children?: React.ReactNode;
}

function CreateWorkingHoursExceptionsFormModal<TData>({ className, semantics }: WorkingHoursFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { siteId = '' } = useParams();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateWorkingHoursException({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_WORKING_HOURS_EXCEPTIONS_RESOURCE] });
            toast({
                title: formatMessage(workingHoursMessages.createWorkingHoursSuccess),
                description: formatMessage(workingHoursMessages.createWorkingHoursSuccessDescription),
            });
        },
    });

    return (
        <WorkingHoursExceptionsFormModal
            className={className}
            mutate={(data, onSuccess, onError) => mutate({ ...data, siteId, parkingId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(workingHoursMessages.addWorkingHoursSubtitle)}
        />
    );
}

export default CreateWorkingHoursExceptionsFormModal;
